/**
 * ============================================================================
 * VINPOP — Translation Helper
 * ============================================================================
 *
 * Exposes window.VinpopTranslations with i18n strings for EN/NL.
 * Used by other scripts that need UI text in the correct language.
 *
 * Loaded from: layout/theme.liquid (global, deferred)
 * ============================================================================
 */

window.VinpopTranslations = {
  // Load from Shopify translations if available
  init: function() {
    // Try to get translations from Shopify theme
    if (window.theme && window.theme.strings) {
      this.strings = window.theme.strings;
    } else {
      // Fallback translations
      this.strings = {
        'subscription.frequency_title': document.documentElement.lang === 'nl' 
          ? 'Hoe vaak wilt u uw wijnbox ontvangen?' 
          : 'How often would you like to receive your wine box?',
        'subscription.frequency_monthly': document.documentElement.lang === 'nl' 
          ? 'Elke maand' 
          : 'Every month',
        'subscription.frequency_bimonthly': document.documentElement.lang === 'nl' 
          ? 'Elke 2 maanden' 
          : 'Every 2 months',
        'subscription.frequency_quarterly': document.documentElement.lang === 'nl' 
          ? 'Elke 3 maanden' 
          : 'Every 3 months',
        'subscription.popular_badge': document.documentElement.lang === 'nl' 
          ? 'Populair' 
          : 'Popular'
      };
    }
    
    // Make translations globally accessible
    window.theme = window.theme || {};
    window.theme.strings = this.strings;
    
    // console.log('🌐 VinPOP translations loaded for language:', document.documentElement.lang);
  },
  
  get: function(key, fallback = '') {
    return this.strings[key] || fallback;
  }
};

// Initialize translations when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  window.VinpopTranslations.init();
});
